export const isGamiclub =
  window.location.hostname.includes("gamiclub") ||
  window.location.hostname.includes("beemobi") ||
  window.location.hostname.includes("mobbfun") ||
  window.location.hostname.includes("gameverse-lt") ||
  window.location.hostname.includes("gami-hub")
    ? // window.location.hostname.includes("localhost")
      true
    : false;

export const isGameverse = window.location.hostname.includes("gameverse-lt");



// WEBPACK FOOTER //
// ./src/constants/isGamiclub.js